import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingIndicator from "layout/components/Loading";
import Table from "components/table/Table";
import { AddButton, SmallScreenModel } from "components";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import { fetchPackages } from "../store/action";
import CreatePackage from "./manage_package/CeatePackage";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const PackagesTable: React.FC<Props> = ({ onFetchPackages, fetchPackages }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onFetchPackages();
  }, [onFetchPackages]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_COMMERCIAL_PACKAGE));
  const { isLoading, packages } = fetchPackages;
  const currentPackages = packages;
  if (isLoading) {
    return <LoadingIndicator />;
  }
  return (
    <div className="">
      <Table
        headers={["Membership Plan", "Packages"]}
        data={currentPackages}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add Package"
                tooltip="Add new package"
              />
            )}
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <CreatePackage closeModal={closeModal} />
        </div>
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchPackages: state.packages?.fetchPackagesState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchPackages: () => dispatch(fetchPackages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PackagesTable);
